import type { accountAssignmentType_enum } from '@vrplatform/graphql';

const descriptions: Record<accountAssignmentType_enum, string | undefined> = {
  deposit_merchantFee: undefined,
  deposit_coHostPayout: undefined,
  deposit_vat: undefined,
  deferredRevenue: undefined,
  accountsPayable: undefined,
  accountsReceivable: undefined,
  expense_reimbursement: undefined,
  deposit_reserve: undefined,
  deposit_channelFee: undefined,
  expense_markup: undefined,
  cancellationRevenue: undefined,
  payout_distribution: undefined,
  payout_bankAccount: undefined,
  expense_salesTax: undefined,
  openingBalance: undefined,
  dueToFromTrust:
    'Tracks trust assets & liabilities—like owner expenses—paid to/from operating, operating expenses paid from trust, and bank transfers between trust and operating bank accounts.',
};

export const getAssignmentTypeDescription = (
  assignmentType: accountAssignmentType_enum | undefined
): string | undefined => {
  if (!assignmentType) return undefined;

  return descriptions[assignmentType];
};
